'use client';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const SidebarGovBadgeDynamic = Dynamic(async () => {
    const { SidebarGovBadge } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarGovBadge.js');
    return { default: SidebarGovBadge };
});
//# sourceMappingURL=SidebarGovBadgeDynamic.js.map